export const SITE_BETA_DISCLAIMER =
  "shops.mt is in early beta. Prices and product information may be inaccurate or out of date — always verify on the retailer's website before purchasing.";

export const SITE_COOKIE_DISCLAIMER =
  'This site uses cookies for analytics and to remember your preferences on this device.';

export const SITE_BETA_TOOLBAR_COPY = 'Help shape Malta’s first shopping search engine — share, follow, or send feedback and make every result better for you.';

export const SITE_BETA_DISCLAIMER_DISMISSED_KEY =
  'shopsmt-beta-disclaimer-dismissed';

export const SITE_BETA_DISCLAIMER_DISMISSED_AT_KEY =
  'shopsmt-beta-disclaimer-dismissed-at';

export const SITE_BETA_TOOLBAR_ELIGIBLE_KEY =
  'shopsmt-beta-toolbar-eligible';

export const SITE_BETA_TOOLBAR_MINIMIZED_KEY =
  'shopsmt-beta-toolbar-minimized';
